<template>
  <div
    v-if="LKStore.loadApp"
    v-show="LKStore.showContent"
  >
    <RouterView />
  </div>
</template>

<script setup>
  import { useLK } from "@/main.js";
  const LKStore = useLK();
</script>

<style lang="scss">

</style>
